import React from "react";
import { Grid, Typography } from "@mui/material";
import CommonButton from "components/commonButton/CommonButton";

function BillAmount(props) {
  const handleApprovModel = () => {
    props?.handleApprovModel();
  };

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="amountSection"
      >
        <Grid item md={11} sm={12}>
          <Typography className="colorPrimary fw600 font20 mb10">
            Total Amount <span className="ml40">₹ {props?.totalAmount}</span>
          </Typography>
          <Typography className="colorGrey font18 fw400">
            Note :- All the invoice contain their respective toll & parking
            details.
          </Typography>
        </Grid>
        <Grid item md={1} sm={12} className="flexend">
          <CommonButton
            name={"Approve"}
            type="submit"
            disabled={!props?.selectedCheckRows?.length > 0}
            btnClass="btnMd btnGreen btnApprov"
            onClick={handleApprovModel}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default BillAmount;
